<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Business Information</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-form>
          <div class="card card-body">
            <label class="form-control-label">Average Contract to Close Length <span id="contract-to-close"><i class="fas fa-question-circle"></i></span></label>
            <b-tooltip target="contract-to-close" triggers="hover" variant="primary">
              If unsure, input 45 days. This can be edited in the portal.
            </b-tooltip>
            <base-input type="number"
                        min="0"
                        max="365"
                        rules="required"
                        name="Contract Length"
                        v-model="team.contract_length"
                        helperText="How many days on average does it take in your market to go from contract accepted to contract closed?">
            </base-input>

            <label class="form-control-label">Ramp Up Period <span id="ramp-up-period"><i class="fas fa-question-circle"></i></span></label>
            <b-tooltip target="ramp-up-period" triggers="hover" variant="primary">
              If unsure, input 10 days. This can be edited in the portal.
            </b-tooltip>
            <base-input type="number"
                        min="0"
                        max="365"
                        rules="required"
                        name="Ramp Up"
                        v-model="team.ramp_up"
                        helperText="How many days on average does it take to go from listing agreement signed to day one on the market?">
            </base-input>

            <label class="form-control-label">Average Days On Market (DOM) <span id="days-on-market"><i class="fas fa-question-circle"></i></span></label>
            <b-tooltip target="days-on-market" triggers="hover" variant="primary">
              If unsure, input 14 days. This can be edited in the portal.
            </b-tooltip>
            <base-input type="number"
                        min="0"
                        max="365"
                        rules="required"
                        name="DOM"
                        v-model="team.dom"
                        helperText="How many days on average does it take to go from day one on market to contract accepted for your listings?">
            </base-input>

            <b-button variant="success" @click="add">Submit</b-button>
          </div>
        </b-form>
      </b-card>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import errorsMixin from '@/mixins/errors-mixin';

export default {
  mixins: [errorsMixin],
  components: {
    RouteBreadCrumb
  },
  data() {
    return {
      team: {
        contract_length: 0,
        ramp_up: 0,
        dom: 0
      }
    };
  },
  computed: {
    userRoute() {
      return process.env.VUE_APP_API_BASE_URL + '/users/' + this.$route.params.user;
    }
  },
  methods: {
    async getTeam() {
      axios.get(this.userRoute + "/team")
      .then(response => {
        this.team = response.data;
      })
      .catch(error => {
        this.error(error);
      })
    },
    async add() {
      axios.patch(this.userRoute + "/teams/" + this.team.slug, {
        contract_length: this.team.contract_length,
        ramp_up: this.team.ramp_up,
        dom: this.team.dom
      })
      .then(response => {
        swal.fire({
          title: `Success`,
          text: response.data,
          showConfirmButton: false,
          timer: 1750,
          icon: 'success'
        });
      })
      .catch(error => {
        this.error(error);
      });
    }
  },
  created() {
    this.getTeam();
  }
}
</script>